import "./styles.css";
import { Header } from "../header-new/header";
import equi from "../../asset-source/invest-bg.png";
import investlaptop from "../../asset-source/investlaptop.png";
import equi2 from "../../asset-source/3d-render.png";
import verify from "../../asset-source/bin-wjet-profile-verify-6.png";
import support from "../../asset-source/bin-wjet-support-7-1.png";
import support2 from "../../asset-source/bin-wjet-chat-7-2.png";
import system from "../../asset-source/bin-wjet-design-system-9.png";
import screenshot from "../../asset-source/bin-wjet-main-page-3.png";
import binlogo from "../../asset-source/binlogo.png";
import mockup from "../../asset-source/bin-wjet-mockup-trade-history-5.png";

import trading from "../../asset-source/bin-wjet-trading-page-4.png";
import mobilebg from "../../asset-source/mobile-bg.png";
import wjetmobile from "../../asset-source/bin-wjet-mobile-8.png";

import { Footer } from "../footer/footer";

import pic1 from "../../asset-source/bin-wjet-mockup-main-2-2.png";
import { useNavigate } from "react-router-dom";

function InvestPage() {
	// document.title =
	// 	"GoChinChin — UX|UI дизайн приложения для знакомств и нетворкинга";
	// document.getElementsByTagName("META")[2].content =
	// 	"GoChinChin — приложение для знакомств и нетворкинга. Интуитивный UX/UI дизайн, продуманный пользовательский путь и удобный интерфейс для общения";

	// document.getElementsByTagName("META")[3].content =
	// 	"UX/UI дизайн, разработка интерфейса приложения, разработка UX/UI дизайна, кейс UX/UI дизайн, проектирование цифровых продуктов, разработка пользовательских сценариев, UX исследования, дизайн для мобильных приложений, UX/UI для приложений знакомств";

	return (
		<div className="invest">
			<div className="wrapper invest__wrapper">
				<Header onLight={true} />

				<div className="container invest__herocontainer">
					<img src={investlaptop} alt="" className="investlaptop" />

					<a href="/" className="allProjectLink">
						<svg
							width="17"
							height="16"
							viewBox="0 0 17 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								id="Arrow 4"
								d="M0.292892 8.70711C-0.0976315 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM17 9H1V7H17V9Z"
								fill="currentColor"
							/>
						</svg>
						Все проекты
					</a>

					<h1 className="h1">
						Платформа для&nbsp;разумных <div className="br" />
						инвестиций
					</h1>
				</div>
				<img src={equi} alt="" className="picture invest__headpicture" />
			</div>

			<div className="feature__wrapper">
				<div className="container">
					<div className="about__title">
						<div className="about__hat">
							<div className="about__titlerow">
								<img src={binlogo} alt="" className="hiddenlogo" />
								Bin
							</div>
							<div className="about__hatinfo">
								Bin — это веб-приложение для торговли бинарными опционами,
								предоставляющее пользователям возможность регистрации,
								пополнения счета и инвестирования средств в криптовалютные
								активы. Платформа включает систему управления счетами, историю
								транзакций, торговый интерфейс с графиками, а также API для
								администрирования через Telegram-бот.
							</div>
						</div>
						<img src={binlogo} alt="" className="about__sideimage" />
					</div>

					<img src={pic1} alt="" className="about__widepic" />

					<div class="infowrapper">
						<div class="textblock">
							<div class="infotitle">Задача</div>
							<div>
								Нашей задачей было разработать интуитивный и удобный
								пользовательский интерфейс для веб-приложения торговли бинарными
								опционами, обеспечить логичную навигацию и адаптивный дизайн.
								Также необходимо было проработать UX-логику, визуализацию данных
								и интеграцию с API серверной части.
							</div>
						</div>
					</div>

					<div class="infowrapper">
						<div class="textblock">
							<div class="infotitle">Решение</div>
							<div>
								Мы создали удобный и адаптивный интерфейс, обеспечивающий
								простую навигацию и наглядное отображение данных. Также
								реализовали интеграцию с API, чтобы все функции платформы
								работали стабильно и без задержек.
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="feature__wrapper invest__violette">
				<div className="container">
					<div className="about__title">
						<div className="about__titlerow">Возможности продукта</div>
					</div>

					<div class="infowrapper noborder">
						<div class="textblock ">
							<div class="infotitle">Главная страница</div>
							<div>
								Главная страница платформы Bin обеспечивает быстрый доступ
								к&nbsp;ключевым функциям сервиса и&nbsp;позволяет пользователям
								контролировать свой баланс, активные сделки и&nbsp;динамику
								торгов.
								<div className="br"></div>
								Главная страница&nbsp;— это&nbsp;не&nbsp;просто визуальный
								элемент, а&nbsp;важный UX-компонент, влияющий на&nbsp;удобство
								и&nbsp;эффективность взаимодействия пользователей
								с&nbsp;платформой.&nbsp;
								<div className="br"></div>
								Пользователь может мгновенно перейти к&nbsp;торговле, выбрать
								актив для&nbsp;инвестирования и&nbsp;воспользоваться встроенной
								поддержкой. Дизайн страницы адаптирован для&nbsp;удобства работы
								как&nbsp;на&nbsp;десктопе, так&nbsp;и&nbsp;на&nbsp;мобильных
								устройствах, обеспечивает интуитивную навигацию и&nbsp;доступ
								ко&nbsp;всем важным функциям.
							</div>
						</div>
					</div>
					<img src={screenshot} alt="" className="about__widepic" />
				</div>
			</div>

			<div className="feature__wrapper invest__trading invest__bg-dark">
				<div className="container">
					<div class="infowrapper noborder">
						<div class="textblock ">
							<div class="infotitle">Торговля</div>
							<div>
								Мы&nbsp;создали удобный интерфейс, где&nbsp;пользователи могут
								быстро выбрать актив, сумму ставки и&nbsp;время экспирации.
							</div>

							<div>
								Система автоматически рассчитывает возможную прибыль,
								а&nbsp;динамический график с&nbsp;маркёрами сделок помогает
								отслеживать изменения цены и&nbsp;результаты торговли.
							</div>
						</div>
					</div>

					<img src={trading} alt="" className="about__widepic" />
				</div>
				<img src={equi2} alt="" className="invest__tradingimage" />
			</div>

			<div className="feature__wrapper invest__instruments">
				<div className="container">
					<div class="infowrapper">
						<div class="textblock">
							<div class="infotitle">Инструменты трейдинга</div>
							<div>
								Мы&nbsp;добавили функции, которые делают процесс торговли более
								удобным и&nbsp;осознанным: гибкие настройки графика,
								моментальные обновления котировок и&nbsp;визуальное отображение
								сделок. Это&nbsp;помогает пользователям быстрее ориентироваться
								в&nbsp;рыночной ситуации и&nbsp;принимать точные решения.
							</div>
						</div>
					</div>

					<div class="infowrapper">
						<div class="textblock">
							<div class="infotitle">История торговли</div>
							<div>
								Для&nbsp;удобного анализа сделок есть&nbsp;раздел История
								торговли, где&nbsp;пользователи могут отслеживать свои операции
								и&nbsp;оценивать результаты. В&nbsp;таблице отображаются актив,
								сумма ставки, время экспирации и&nbsp;исход сделки,
								что&nbsp;помогает оценивать эффективность стратегии
								и&nbsp;принимать более обоснованные решения. Особенно полезен
								этот&nbsp;раздел для&nbsp;опытных трейдеров&nbsp;—
								он&nbsp;позволяет быстро анализировать успешные и&nbsp;неудачные
								стратегии, контролировать финансовые результаты
								и&nbsp;корректировать тактику на&nbsp;основе прошлых сделок.
							</div>
						</div>
					</div>

					<img src={mockup} alt="" className="about__widepic" />
				</div>
			</div>

			<div className="feature__wrapper invest__violette">
				<div className="container">
					<div class="infowrapper noborder">
						<div class="textblock ">
							<div class="infotitle">Профиль и&nbsp;верификация</div>
							<div>
								В&nbsp;личном кабинете пользователи могут управлять своими
								данными, просматривать историю операций и&nbsp;изменять
								настройки безопасности. Для&nbsp;защиты средств предусмотрена
								обязательная верификация&nbsp;— загрузка паспорта
								или&nbsp;другого документа подтверждает личность
								и&nbsp;открывает доступ к&nbsp;выводу средств. Это&nbsp;повышает
								безопасность сервиса и&nbsp;защищает пользователей
								от&nbsp;мошенничества.
								<div className="br"></div>
								В&nbsp;блокчейн-индустрии, где&nbsp;анонимность часто сопряжена
								с&nbsp;высокими рисками, верификация играет ключевую роль,
								обеспечивая защиту платформы и&nbsp;её&nbsp;пользователей.
								Мы&nbsp;уделяем особое внимание проработке верификации
								и&nbsp;безопасности при&nbsp;проектировании таких сервисов,
								чтобы&nbsp;обеспечить надёжность платформы и&nbsp;удобство
								для&nbsp;пользователей.
							</div>
						</div>
					</div>
					<img src={verify} alt="" className="about__widepic" />
				</div>
			</div>

			<div className="feature__wrapper invest__tech">
				<div className="container">
					<div class="infowrapper noborder">
						<div class="textblock ">
							<div class="infotitle">Тех&nbsp;поддержка</div>
							<div>
								Мы&nbsp;предусмотрели удобную систему технической поддержки,
								чтобы&nbsp;пользователи могли быстро получать помощь
								в&nbsp;любых вопросах. Раздел включает историю обращений
								и&nbsp;встроенный чат, позволяя оперативно общаться
								с&nbsp;командой поддержки.
							</div>

							<div>
								Все&nbsp;запросы фиксируются, а&nbsp;пользователи получают
								уведомления о&nbsp;статусе решения их&nbsp;проблемы,
								что&nbsp;делает взаимодействие с&nbsp;сервисом комфортным
								и&nbsp;прозрачным.
							</div>
						</div>
					</div>
					<div className="doubleimages">
						<img src={support} alt="" />
						<img src={support2} alt="" />
					</div>
				</div>
			</div>

			<div className="feature__wrapper invest__trading invest__trading-nopadding">
				<div className="container">
					<div class="infowrapper noborder">
						<div class="textblock ">
							<div class="h2">Мобильная версия</div>
							<div>
								Платформа адаптирована для&nbsp;удобной работы на&nbsp;мобильных
								устройствах, сохраняя все&nbsp;ключевые функции: управление
								ставками, график цен, историю сделок и&nbsp;доступ
								к&nbsp;финансам. Оптимизированная навигация и&nbsp;интуитивный
								интерфейс позволяют легко отслеживать рынок и&nbsp;заключать
								сделки в&nbsp;любом месте и&nbsp;в&nbsp;любое время.
								Особенностью мобильной версии является удобная работа
								с&nbsp;активными сделками&nbsp;— пользователи могут быстро
								переключаться между&nbsp;ними и&nbsp;видеть ключевые данные
								прямо на&nbsp;графике.
							</div>
						</div>
						<img src={wjetmobile} alt="" className="about__chinchinmobile" />
					</div>

					<img src={mobilebg} alt="" className="invest__tradingimage" />
				</div>
			</div>

			<div className="feature__wrapper invest__designsystem">
				<div className="container">
					<div class="infowrapper noborder">
						<div class="textblock ">
							<div class="h2">Дизайн система</div>
							<div>
								Для проекта была разработана гибкая дизайн-система, которая
								обеспечивает визуальную согласованность и ускоряет работу с
								интерфейсами. Темная цветовая палитра с хорошим контрастом
								делает интерфейс удобным для глаз, а адаптивная типографика
								обеспечивает легкость чтения на любых устройствах.
								<div className="br" />
								Дизайн-система включает 34 готовых компонента, что позволяет
								быстро масштабировать интерфейс и поддерживать единый стиль во
								всех разделах. Кроме того, используется модульная система
								отступов и размеров, которая делает интерфейс структурированным
								и удобным в использовании.
							</div>
						</div>
					</div>
					<img src={system} alt="" className="about__widepic" />
				</div>
			</div>
			<div className="footerwrapper">
				<div className="container">
					<Footer backgroundColor="transparent" />
				</div>
			</div>
		</div>
	);
}

export default InvestPage;
